import { FC, memo } from 'react';
import { Link } from 'react-router';
import styled from 'styled-components';

import { AUTH_ROUTES } from '@navigation/types';
import AuthLayout from '@components/layouts/AuthLayout';
import AuthTitle from '@components/auth/AuthTitle';
import AuthOptions from '@components/auth/AuthOptions';
import { SignUpForm } from '@components/form/SignUpForm';
import { PremierText, GradientPremierText } from '@components/text';
import TouchableOpacity from '@components/buttons/TouchableOpacity';

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  margin-top: 36px;
`;

const LoginButton = styled(TouchableOpacity)`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;
  background: transparent;
`;

const LoginText = styled(GradientPremierText)`
  font-size: ${({ theme }) => theme.fonts.fontSize['2xl']};
  text-decoration: underline;
  text-decoration-color: ${({ theme }) => theme.colors.purple[500]};

  &:hover {
    opacity: 0.8;
  }
`;

const SignUp: FC = () => {
  return (
    <AuthLayout>
      <ContentContainer>
        <AuthTitle
          title='Join Omili'
          subtitle='Create your account using one of the options below'
        />

        <AuthOptions />

        <SignUpForm />

        <PremierText>Already have an account?</PremierText>

        <LoginButton as={Link} to={AUTH_ROUTES.LOGIN}>
          <LoginText>Log In</LoginText>
        </LoginButton>
      </ContentContainer>
    </AuthLayout>
  );
};

export default memo(SignUp);
